import { Component, OnInit } from '@angular/core';
import {ProjectService} from "@catcore/services";
import {isNullOrUndefined} from "util";
import {GgwDevZoneAssignmentService} from "@catmodels/ggw-dev-zone-assignment/services/ggw-dev-zone-assignment.service";
import {Project} from "@catcore/types/api-v2";
import {Subscription} from "rxjs";
import {DisplayTypes} from "@catui/components/panel/types";
import {GenericLinkedResource} from "@catcore/types/base";
import {ModifyGgwDevZoneAssignmentComponent} from "@catmodels/ggw-dev-zone-assignment/components/modify-ggw-dev-zone-assignment/modify-ggw-dev-zone-assignment.component";
import {ModalService} from "@catmodules/widgets/slide-in-modal/services/modal.service";
import {GenericResourceService} from "@catfeatures/services/generic-resource.service";
import {BreadcrumbService} from "@catmodules/widgets/breadcrumb/services/breadcrumb.service";
import {ModifyGgwProfileComponent} from "@catmodels/ggw-profiles/components/modify-ggw-profile/modify-ggw-profile.component";
import {ModifyGgwDeviceComponent} from "@catmodels/ggw-device/components/modify-ggw-device/modify-ggw-device.component";
import {GgwProfile} from "@catmodels/ggw-profiles/types";

@Component({
  selector: 'catapp-ggw-dev-zone-assignment',
  templateUrl: './ggw-dev-zone-assignment.component.html',
  styleUrls: ['./ggw-dev-zone-assignment.component.scss']
})
export class GgwDevZoneAssignmentComponent implements OnInit {

  tableItems = [];
  dataTableInitialized: boolean;
  project: Project;

  guiZones = [];
  ggwDevices = [];
  zoneAssignments = [];
  defaultZoneAssignments = [];

  zoneAssignmentsInitialized: boolean = false;
  defaultZoneAssignmentsInitialized: boolean = false;
  ggwDevicesInitialized: boolean = false;


  panelDisplayType = DisplayTypes;

  cols = [];
  staticCols = [
    { field: 'parentZoneLabel', header: 'Zone', parentShortName: 'GGW Device', static: true },
    { field: 'description', header: 'Device', parentShortName: 'GGW Device', static: true },
    { field: 'resolvedConfigName', header: 'Config Name', parentShortName: 'GGW Device', static: true },
    { field: 'class', header: 'Class', parentShortName: 'GGW Device', static: true },
    { field: 'roleLabel', header: 'Role', parentShortName: 'GGW Device', static: true },
    { field: 'aircraftDevice', header: 'AC-wide', parentShortName: 'GGW Device', static: true },
  ];

  groupCols = [];
  staticGroupCols = [
    { shortName: 'GGW Device', count: this.staticCols.length, children: this.staticCols }
  ];

  projectSubscription: Subscription;
  ggwDeviceSubscription: Subscription;
  ggwDevZoneAssignmentSubscr: Subscription;
  ggwDefaultZoneAssignmentSubscr: Subscription;

  showSeats = false;

  constructor(private projectService: ProjectService,
              private ggwDevZoneAssignmentService: GgwDevZoneAssignmentService,
              private modalService: ModalService,
              private genericService: GenericResourceService,
              private breadcrumbService: BreadcrumbService) { }

  ngOnInit() {
    // first get the current project
    this.projectSubscription = this.projectService.getCurrentProject()
      .subscribe((project) => {
        const isActiveProject = !isNullOrUndefined(project) && !isNullOrUndefined(project.id);
        if (isActiveProject) {
          this.dataTableInitialized = false;
          this.ggwDevicesInitialized = false;
          this.zoneAssignmentsInitialized = false;
          this.defaultZoneAssignmentsInitialized = false;

          this.project = project;
          this.ggwDevZoneAssignmentService.setActive();
          if (this.ggwDevZoneAssignmentSubscr) {
            this.ggwDevZoneAssignmentSubscr.unsubscribe();
          }

          this.guiZones = this.projectService.extractGuiZonesFrom(this.project);
          this.guiZones = this.guiZones.filter((guiZone) => {
            return guiZone.type === 'seat' || guiZone.type === 'zone';
          });

          this.ggwDevZoneAssignmentSubscr = this.projectService.getGgwDevZoneAssignments(this.project)
            .subscribe((zoneAssignments: any) => {
              this.zoneAssignments = zoneAssignments;
              this.zoneAssignmentsInitialized = true;
              this.updateDataTable();
            });

          this.ggwDefaultZoneAssignmentSubscr = this.projectService.getGgwDefaultZoneAssignments(this.project)
            .subscribe((defaultZoneAssignments: any) => {
              this.defaultZoneAssignments = defaultZoneAssignments;
              this.defaultZoneAssignmentsInitialized = true;
              this.updateDataTable();
            });

          this.ggwDeviceSubscription = this.projectService.getAllGgwDevices(this.project, true)
            .subscribe((ggwDevices: any) => {
              this.ggwDevices = ggwDevices;
              this.ggwDevicesInitialized = true;
              this.updateDataTable();
            });
        }
      });

    this.breadcrumbService.update([{label: 'Zone Assignment', value: 'ggwDeviceZoneAssignment' }]);
  }

  ngOnDestroy() {
    this.ggwDevZoneAssignmentSubscr.unsubscribe();
    this.projectSubscription.unsubscribe();
    this.ggwDeviceSubscription.unsubscribe();
    this.ggwDevZoneAssignmentService.setInActive();
  }

  /**
   * Returns true if the edit button should be displayed for a cell.
   *
   * @param rowItem
   * @param colField
   */
  showEditButton(rowItem, colField) {
    return colField === 'description';
  }

  /**
   * Handles a click on the edit button of a profile.
   *
   * @param rowItem
   * @param colField
   */
  editButtonClick(rowItem, colField) {
    const ggwDevice = rowItem.ggwDevice;
    this.openModalForGgwProfile(ggwDevice);
  }

  setShowSeats(value) {
    this.showSeats = value;
    this.updateCols();
  }

  /**
   * Updates the data table items.
   */
  private updateDataTable() {
    if (!this.ggwDevicesInitialized
        || !this.zoneAssignmentsInitialized
        || !this.defaultZoneAssignmentsInitialized) {
      return;
    }

    this.updateCols();

    this.tableItems = [];
    this.ggwDevices.forEach((ggwDevice) => {
      const item = {
        'parentZoneLabel': ggwDevice._links.gui_zone.label,
        'naturalZones': this.getDefaultAssignments(ggwDevice),
        'ggwDevice': ggwDevice,
        'description': ggwDevice.resolved_description,
        'configName': ggwDevice.config_name,
        'aircraftDevice': ggwDevice.aircraft_device ? 'Yes' : 'No',
        'resolvedConfigName': ggwDevice.resolved_config_name,
        'class': ggwDevice.class,
        'roleLabel': ggwDevice.role_label,
        'zoneAssignments': {},
      };
      this.zoneAssignments
        .filter((za) => za._links.ggw_device.href === ggwDevice._links.self.href)
        .forEach((za) => {
        item.zoneAssignments[za._links.gui_zone.href] = za;
      });
      this.tableItems = [...this.tableItems, item];
    })
  }


  private getDefaultAssignments(ggwDevice) {
    if (this.defaultZoneAssignments.hasOwnProperty(ggwDevice._links.self.href)) {
      return this.defaultZoneAssignments[ggwDevice._links.self.href];
    } else {
      return [];
    }
  }

  /**
   * Updates the table columns, both for the group header cols and the data cols.
   */
  private updateCols() {
    let dataCols = [];
    this.guiZones
      .filter((guiZone) => guiZone.type !== 'seat' || this.showSeats)
      .forEach((guiZone) => {
      const col = {
        field: guiZone._links.self.href,
        header: guiZone.short_name,
        parentShortName: this.getParentShortName(guiZone),
        static: false
      };
      dataCols.push(col);
    });
    dataCols.sort((a, b) => {
      let parentZoneCmp = a.parentShortName.toUpperCase().localeCompare(b.parentShortName.toUpperCase());
      if (parentZoneCmp !== 0) {
        return parentZoneCmp;
      }
      return a.header.toUpperCase().localeCompare(b.header.toUpperCase());
    });

    let colspanCount = dataCols.reduce((p, c) => {
      let name = c.parentShortName;
      if (!p.hasOwnProperty(name)) {
        p[name] = {
          count: 0,
          children: []
        };
      }
      p[name].count++;
      p[name].children.push(c);
      return p;
    }, {});

    let dataColspanCount = Object.keys(colspanCount).map(k => {
      return {
        shortName: k,
        count: colspanCount[k].count,
        children: colspanCount[k].children
      };
    });

    this.groupCols = [
      ...this.staticGroupCols,
      ...dataColspanCount
    ];
    this.cols = [
      ...this.staticCols,
      ...dataCols
    ];
  }

  /**
   * Returns true if the ggw device is included in the given zone by default.
   *
   * @param rowItem
   * @param colField
   */
  isNaturalZone(rowItem, colField) {
    return rowItem.naturalZones.find((zoneUri) => zoneUri === colField) !== undefined;
  }

  /**
   * Returns true if the ggw device is included in the given zone
   *
   * @param rowItem
   * @param colField
   */
  isActive(rowItem, colField) {
    if (this.isNaturalZone(rowItem, colField)) {
      return !(rowItem.zoneAssignments.hasOwnProperty(colField) && rowItem.zoneAssignments[colField].type === 'exclude');
    } else {
      return rowItem.zoneAssignments.hasOwnProperty(colField) && rowItem.zoneAssignments[colField].type === 'include';
    }
  }

  /**
   * Returns true if attributes of the ggw device zone assignment have been set
   *
   * @param rowItem
   * @param colField
   */
  hasAttributes(rowItem, colField) {
    let za = rowItem.zoneAssignments[colField];
    return za && (
      za.icon_x.length > 0 || za.icon_y.length > 0
    );
  }

  /**
   * Returns true if the given column name belongs to a static column.
   *
   * @param colName
   */
  isStaticCol(colName) {
    return this.staticCols.find((c) => c.field === colName);
  }

  /**
   * Includes the ggw device into the gui zone, either by removing a zone assignment that excluded a ggw
   * device from its default zone, or by adding a new zone assignment that includes a ggw device into a new zone.
   *
   * @param rowData
   * @param guiZoneUri
   */
  activate(rowData, guiZoneUri) {
    if (this.isStaticCol(guiZoneUri)) {
      return;
    }
    if (this.isNaturalZone(rowData, guiZoneUri)) {
      this.deleteItem(rowData.zoneAssignments[guiZoneUri]);
    } else {
      this.addItem(rowData.ggwDevice._links.self.href, guiZoneUri, 'include');
    }
  }

  /**
   *
   * @param rowData
   * @param guiZoneUri
   */
  edit(rowData, guiZoneUri) {
    const za = rowData.zoneAssignments[guiZoneUri];
    if (za) {
      this.openDialog(za._links.self, (za) => this.ggwDevZoneAssignmentModalFactory(za));
    } else {
      this.ggwDevZoneAssignmentModalFactory({
        _links: {
          ggw_device: {
            href: rowData.ggwDevice._links.self.href,
            label: rowData.ggwDevice.name,
          },
          gui_zone: {
            href: guiZoneUri,
            label: this.getGuiZoneLabel(guiZoneUri)
          }
        },
        _embedded: {
          ggw_device: rowData.ggwDevice,
        },
        type: 'include',
        icon_roles: [],
        icon_x: [],
        icon_y: [],
      });
    }
  }

  /**
   * Adds a new ggw dev zone assignment relationship with the given type
   *
   * @param ggwDeviceUri
   * @param guiZoneUri
   * @param type 'include' or 'exclude'
   */
  addItem(ggwDeviceUri, guiZoneUri, type) {
    this.ggwDevZoneAssignmentService.add({
      ggw_device: ggwDeviceUri,
      gui_zone: guiZoneUri,
      type: type
    })
      .subscribe((result) => {
        this.zoneAssignments.push(result);
        this.updateTableItem(ggwDeviceUri, guiZoneUri, result);
      });
  }

  /**
   * Excludes the ggw device from the gui zone, either by adding a zone assignment that excludes a ggw
   * device from its default zone, or by removing a zone assignment that included a ggw device into a zone.
   *
   * @param rowData
   * @param guiZoneUri
   */
  deactivate(rowData, guiZoneUri) {
    if (this.isStaticCol(guiZoneUri)) {
      return;
    }
    const item = rowData.zoneAssignments[guiZoneUri];
    if (item) {
      this.deleteItem(item);
    }

    if (this.isNaturalZone(rowData, guiZoneUri)) {
      this.addItem(rowData.ggwDevice._links.self.href, guiZoneUri, 'exclude');
    }
  }

  /**
   * Deletes a given zone assignment relationship.
   *
   * @param item the zone assignment
   */
  deleteItem(item) {
    this.ggwDevZoneAssignmentService.delete(item)
      .subscribe((result) => {
        let index = this.zoneAssignments.indexOf(item);
        this.tableItems
          .filter((tableItem) => {return item._links.ggw_device.href === tableItem.ggwDevice._links.self.href})
          .forEach((tableItem) => {
            if (tableItem.zoneAssignments.hasOwnProperty([item._links.gui_zone.href])) {
              delete tableItem.zoneAssignments[item._links.gui_zone.href];
            }
          });
        this.zoneAssignments.splice(index, 1);
      });
  }

  /**
   * Returns true if the explicit assignment differs from the default assignment.
   *
   * @param rowItem
   * @param colField
   */
  hasDifferentDefault(rowItem, colField) {
    const currentState = this.isActive(rowItem, colField);
    const defaultState = this.isNaturalZone(rowItem, colField);
    return currentState !== defaultState;
  }

  private getParentShortName(guiZone) {
    if (guiZone._embedded && guiZone._embedded.zone_parent) {
      return guiZone._embedded.zone_parent.short_name;
    } else {
      return guiZone.short_name;
    }
  }

  private afterItemUpdate(updatedZoneAssignment) {
    let zaIndex = this.zoneAssignments.findIndex((za) => za.id === updatedZoneAssignment.id);
    if (zaIndex > -1) {
      this.zoneAssignments.splice(zaIndex, 1);
    }
    this.zoneAssignments.push(updatedZoneAssignment);

    const ggwDeviceUri = updatedZoneAssignment._links.ggw_device.href;
    const guiZoneUri = updatedZoneAssignment._links.gui_zone.href;
    this.updateTableItem(ggwDeviceUri, guiZoneUri, updatedZoneAssignment);
  }

  private afterGgwDeviceUpdate(ggwDevice) {
    this.tableItems.filter((p) => { return p.ggwDevice.id === ggwDevice.id})
      .forEach((item) => {
        item['description'] = ggwDevice.resolved_description;
        item['resolvedConfigName'] = ggwDevice.resolved_config_name;
        item.ggwDevice = ggwDevice;
      });
  }

  private updateTableItem(ggwDeviceUri, guiZoneUri, zoneAssignment) {
    this.tableItems
      .filter((item) => {return item.ggwDevice._links.self.href === ggwDeviceUri})
      .forEach((item) => {
        item.zoneAssignments[guiZoneUri] = zoneAssignment;
      });
  }

  private getGuiZoneLabel(guiZoneUri) {
    const zone = this.guiZones.find((zone) => zone._links.self.href === guiZoneUri);
    return zone ? zone.name : '';
  }

  private ggwDevZoneAssignmentModalFactory(zoneAssignment) {
    const compRef = this.modalService.open(ModifyGgwDevZoneAssignmentComponent);
    compRef.componentInstance.zoneAssignment = zoneAssignment;
    compRef.componentInstance.afterUpdate.subscribe((item) => {this.afterItemUpdate(item)});
    return compRef;
  }

  private openDialog(resource: GenericLinkedResource, componentFactory) {
    let compRef;
    const onFullfill = () => {

    };

    const onError = () => {
      //this.unitSubscription.unsubscribe();
    };

    const resourceHandler = this
      .genericService
      .findServiceForResource(resource.href);

    resourceHandler
      .loadAndGet()
      .subscribe((item) => {
        if (compRef) {
          compRef.close();
          compRef = null;
        }

        if (isNullOrUndefined(item)) {
          compRef = null;
        } else {
          compRef = componentFactory(item);
          compRef.result.then(onFullfill, onError);
        }
      });
  }

  openModalForGgwProfile(ggwDevice) {
    const compRef = this.modalService.open(ModifyGgwDeviceComponent);
    compRef.componentInstance.ggwDevice = ggwDevice;
    compRef.componentInstance.afterUpdate.subscribe((res) => this.afterGgwDeviceUpdate(res));
    return compRef;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/ggw-dev-zone-assignment/components/ggw-dev-zone-assignment/ggw-dev-zone-assignment.component.ts